<template>
  <div class="activity-container">
    <div class="activity-inner-container">
      <div class="title-container">
        <h2>一起烧烤吧</h2>
        <a class="share-btn">分享</a>
      </div>
      <img
        class="cover"
        src="https://pic4.zhimg.com/v2-91bac82b1d3de6a603877be0ea569e5f_b.jpg"
      />
      <h3 class="item-title">报名时间</h3>
      <div>
        <span class="item-content">2019-10-12 14:00</span>
        <span class="item-content">至</span>
        <span class="item-content">2019-10-13 16:00</span>
      </div>

      <h3 class="item-title">活动时间</h3>
      <div>
        <span class="item-content">2019-10-12 14:00</span>
        <span class="item-content">至</span>
        <span class="item-content">2019-10-13 16:00</span>
      </div>

      <h3 class="item-title">活动地点</h3>
      <p class="item-content">广州海珠区白石路1号滨江设计中心雕刻时光咖啡馆</p>

      <h3 class="item-title">目标人数</h3>
      <p class="item-content">最少20人、最多30人</p>

      <h3 class="item-title">已报名</h3>
      <p class="item-content">23人（男生12人，女生11人）</p>

      <h3 class="item-title">活动发起方</h3>
      <p class="item-content">Luca</p>

      <h3 class="item-title">活动费用</h3>
      <p class="item-content">145元/人</p>

      <h3 class="item-title">活动详情</h3>
      <p class="item-content">活动描述活动描述活动描述活动描述活动描述活动描述活动描述活动描述活动描述活动描述活动描述活动描述</p>

    </div>
    <a class="apply-btn">立即报名</a>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import Storage from "@/utils/Storage";
import Login from "@/components/common/login";
import buttomTips from "@/components/common/buttomTips";
import banModal from "../../personList/component/banModal";

export default {
  name: "account",
  components: {
    Login,
    buttomTips,
    banModal
  },
  data() {
    return {
      list: undefined,
      currentId: undefined,
      isShowDialog: false,
      dialogConfirmText: "我知道了",
      notShowAgain: false,
      unWatcher: null,
      currentPage: 1,
      pageSize: 20,
      isLoading: false,
      finished: false,
      showModal: false
    };
  },
  computed: {
    ...mapState({
      userData: "userData"
    }),
    ...mapState("message", {
      unreadCount: "unreadCount"
    }),
    ...mapGetters({
      userId: "userId"
    }),
    /**
     * @description 将消息列表重构成以下形式
     *  1、官方消息合并
     *  2、官方消息排在首位
     *  3、合并后的官方消息，ids为未读消息数组
     */
    mergeList() {
      let list = [];
      let official = null;
      let ids = [];
      if (this.list) {
        list = this.list.filter(item => {
          if (item.fromMid == 0) {
            // 官方消息
            if (item.status == 0) {
              ids.push(item.id);
            }
            official = item;
          } else {
            return true;
          }
        });
      }
      if (official) {
        if (ids.length) {
          official.ids = ids;
        }
        // 官方消息排在首位
        list.unshift(official);
      }
      return list;
    }
  },
  methods: {
    ...mapMutations("message", {
      updateUnreadCount: "updateUnreadCount"
    }),
    jump(userId, id, item) {
      if (!userId) {
        // 官方消息
        this.$router.push({
          path: `/message-detail-${userId === "" ? 0 : userId}.html`
        });
      } else {
        if (item.singleStatus === 6 || item.singleStatus === 7) {
          this.showModal = true;
        } else {
          this.popup(userId);
        }
      }
      (item.status == 0 || item.ids || item.id) &&
        this.$http("/api/member/message/read", {
          targetMemberId: item.fromMemberId
        }).then(
          res => {
            if (res.code === "0000") {
              item.status = 1;
              if (this.unreadCount > 0) {
                let num = item.ids ? item.ids.length : 1;
                this.updateUnreadCount(this.unreadCount - num);
              }
            } else {
              this.$toast(res.msg);
            }
            this.isLoading = false;
          },
          err => {
            this.isLoading = false;
            this.$toast(err);
          }
        );
    },
    toDetail() {
      this.$router.push({
        path: `/info-${this.currentId}.html`
      });
    },
    popup(id) {
      this.currentId = id;
      if (!Storage.load("neverPopMessage")) {
        this.isShowDialog = true;
        return;
      }

      // 直接跳转到个人详情页
      this.toDetail();
    },
    checkKnown() {
      this.notShowAgain = !this.notShowAgain;
    },
    confirm() {
      if (this.notShowAgain) {
        Storage.save("neverPopMessage", true);
      } else {
        Storage.save("neverPopMessage", false);
      }
    },
    closed() {
      // 直接跳转到个人详情页
      this.toDetail();
    },
    fetchMessage() {
      this.isLoading = true;
      this.$http(
        "/api/member/message/list",
        {
          currentPage: this.currentPage,
          pageSize: this.pageSize
        },
        "get"
      ).then(
        res => {
          this.isLoading = false;
          if (res.code === "0000") {
            this.list = res.data.data || [];
            if (this.currentPage >= res.data.pageCount) {
              this.finished = true;
            } else {
              this.finished = false;
            }
            this.currentPage++;
          } else {
            res.code !== "100005" && this.$toast(res.msg);
            this.finished = true;
          }
        },
        err => {
          this.isLoading = false;
          this.$toast(err);
        }
      );
    }
  },
  watch: {
    userId(val) {
      this.currentPage = 1;
      this.fetchMessage();
    }
  },
  activated() {
    this.unWatcher = this.$watch("unreadCount", val => {
      if (parseInt(val) >= 0) {
        this.currentPage = 1;
        this.fetchMessage();
      }
    });
  },
  deactivated() {
    // this.unWatcher && this.unWatcher()
  },
  mounted() {
    // this.userId && this.fetchMessage()
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/constant.scss";
.activity-container {
  .activity-inner-container {
    display: flex;
    flex-direction: column;
    padding: 0 0.53333rem;
  }
  .title-container {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }
  .share-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #ff3e90;
    border-radius: 20px;
    width: 100px;
    color: #ff3e90;
  }
  .cover {
    width: 100%;
    border-radius: 10px;
  }
  .item-title {
    font-size: 28px;
    font-weight: bold;
    margin: 20px 0;
  }
  .item-content {
    font-size: 28px;
    color: rgba(0,0,0,0.4);
  }
  .apply-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 25px;
    color: #fff;
    line-height: 50px;
    background: #ff3e90;
    position: fixed;
    bottom: 0;
    font-size: 28px;
    font-weight: bold;
  }
}
</style>
